<template>
  <div class="odmik-vsebine-poraba-telefonija">
    <div v-if="prikazTabele === '1'">
      <el-table :data="seznamNosilci" v-loading="nalaganjePorabaStroskovniNosilci" empty-text="Ni podatkov">
        <el-table-column prop="nazivNosilca"
                         label="Stroškovni nosilec">
        </el-table-column>
        <el-table-column label="Število klicev"
                         prop="call_count">
        </el-table-column>
        <el-table-column label="Trajanje (v sek.)"
                         prop="call_duration">
        </el-table-column>
        <el-table-column label="Število sporočil"
                         prop="message_count">
        </el-table-column>
        <el-table-column prop="data_quantity_kb"
                         label="Podatkovni promet">
        </el-table-column>
        <el-table-column prop="amount"
                         label="Znesek v € (z DDV)">
        </el-table-column>
      </el-table>
    </div>
    <div v-if="prikazTabele === '0'">
      <el-table :data="seznamNosilci" empty-text="Ni podatkov">
        <el-table-column>
          <template slot-scope="props">
            <p>
              <span>
                <b>
                  Stroškovni nosilec:
                </b>
              </span>
              {{ props.row.nazivNosilca }}
            </p>
            <p>
              <span>
                <b>
                  Število klicev:
                </b>
              </span>
              {{ props.row.call_count }}
            </p>
            <p>
              <span>
                <b>
                  Trajanje (v sek.):
                </b>
              </span>
              {{ props.row.call_duration }}
            </p>
            <p>
              <span>
                <b>
                  Število sporočil:
                </b>
              </span>
              {{ props.row.message_count }}
            </p>
            <p>
              <span>
                <b>
                  Podatkovni promet:
                </b>
              </span>
              {{ props.row.data_quantity_kb }}
            </p>
            <p>
              <span>
                <b>
                  Znesek v € (z DDV):
                </b>
              </span>
              {{ props.row.amount }}
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-center">
      <el-pagination
        :hide-on-single-page="true"
        @current-change="PrikaziStran"
        :current-page="trenutnoIzbranaStran"
        :page-size="4"
        layout="prev, pager, next"
        :total="dolzinaSeznamaStroskovniPregled"
        small>
      </el-pagination>
    </div>
    <div style="padding-top: 30px" v-if="seznamNosilci.length > 0">
      <el-button class="gumb-potrdi">
        <download-excel
          :data="tempSeznamNosilci.flat()"
          :fields="jsonFieldsVsiStroskovniNosilci"
          worksheet="Dnevnik vseh stevilk"
          name="Izpis_vseh_stroskovnih_nosilcev.xls">
          <img src="../../../../../../static/img/Icon/PorabaTelefonija/Icon-file-excel-regular.png">
          IZVOZ PORABE NOSILCEV
        </download-excel>
      </el-button>
    </div>
    <span class="opozorilo">
      <el-icon class="el-icon-info" style="padding-top: 5px;">
      </el-icon>
      <span class="opozorilo-mobile">
        Izvoz porabe na stroškovni nosilec je informativne narave, zgodovino beležimo za zadnje 3 mesece.
      </span>
    </span>
  </div>
</template>
<script>
import Vue from 'vue'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {ObdelavaDatuma} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/IzbiraMeseca.js'
import {PretvorbaEnot} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PretvorbaEnotB.js'
import {PregledNosilcev} from 'src/assets/js/globalne_funkcije/GlobalnoTelefonija/PregledNosilcev.js'
import {Checkbox, Button, Select, Option, Card, Table, TableColumn} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)
export default {
  name: 'StroskovniPregled',
  mixins: [PrikazVsebine, PregledNosilcev, ObdelavaDatuma, PretvorbaEnot],
  data () {
    return {
      clientAgent: null,
      izbranSap: '',
      izbranMesec: '',
      idStroskovniNosilec: '',
      nalaganjePorabaStroskovniNosilci: false,
      tempSeznamNosilci: [],
      seznamNosilci: [],
      dolzinaSeznamaStroskovniPregled: null,
      trenutnoIzbranaStran: 1,
      stZakljucenihKlicevWsNosilci: 0,
      jsonFieldsVsiStroskovniNosilci: {
        'Stroškovni nosilec': 'nazivNosilca',
        'Število klicev': 'call_count',
        'Trajanje (v sek.)': 'call_duration',
        'Število sporočil': 'message_count',
        'Podatkovni promet': 'data_quantity_kb',
        'Znesek v € (z DDV)': 'amount'
      },
      json_meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ]
    }
  },
  components: {
    PregledNosilcev,
    ObdelavaDatuma,
    PretvorbaEnot,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: {
    izbranSapParam: null,
    izbranMesecParam: '',
    izbranid: null
  },
  computed: {
    KombinacijaMesecSap () {
      if (this.izbranMesecParam !== '') {
        return this.izbranSapParam + '|' + this.izbranMesecParam
      }
    }
  },
  watch: {
    KombinacijaMesecSap (newVal) {
      let [a1, b1] = newVal.split('|')
      this.izbranSap = a1
      this.izbranMesec = b1
      let param = {}
      param.vmesnik = this
      param.prenesenIzbranId = this.izbranid
      this.PridobiNosilce(param)
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.izbranMesec = this.izbranMesecParam
    let param = {}
    param.vmesnik = this
    param.prenesenIzbranId = this.izbranid
    this.PridobiNosilce(param)
    this.DolociIzbranMesec()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    SetSeznamStroskovnihNosilcev (prenosniParametri, seznamStrNos) {
      if (this.izbranid === prenosniParametri.prenesenIzbranId) {
        this.seznamStroskovnihNosilcev = seznamStrNos
        this.PregledPorabeNosilcev()
      }
    },
    PregledPorabeNosilcev () {
      this.idStroskovniNosilec = ''
      if (this.izbranid !== '') {
        this.nalaganjePorabaStroskovniNosilci = true
        let izbranoObdobje = this.DolociIzbranMesec()
        this.stZakljucenihKlicevWsNosilci = 0
        this.tempSeznamNosilci = []
        for (let i = 0; i < this.seznamStroskovnihNosilcev.length; i++) {
          this.idStroskovniNosilec = this.seznamStroskovnihNosilcev[i].id_expense_account
          let prenosniParametri = {}
          prenosniParametri.call_count = this.seznamStroskovnihNosilcev.length
          prenosniParametri.nazivNosilca = this.seznamStroskovnihNosilcev[i].naziv
          let param = ['idStranka=' + this.izbranid]
          param.push('idExpenseAccount=' + this.idStroskovniNosilec)
          param.push('trajanjeOd=' + izbranoObdobje.trajanjeOd)
          param.push('trajanjeDo=' + izbranoObdobje.trajanjeDo)
          this.clientAgent.postWsRequest(this,
            'mercury/porabaStroskovniNosilec?',
            param,
            prenosniParametri,
            'SetPregledNosilce',
            'ErrPregledNosilce',
            300000)
        }
      }
    },
    SetPregledNosilce (podatki, prenosniParametri) {
      for (let i = 0; i < podatki.data.length; i++) {
        podatki.data[i].nazivNosilca = prenosniParametri.nazivNosilca
        this.tempSeznamNosilci.push(podatki.data[i])
      }
      this.stZakljucenihKlicevWsNosilci++
      if (prenosniParametri.call_count === this.stZakljucenihKlicevWsNosilci) {
        for (const nosilec of this.tempSeznamNosilci) {
          nosilec.data_quantity_kb = this.PretvoriKolicinoVPrijaznoObliko(nosilec.data_quantity_kb)
          this.davek = (100 + Number.parseFloat(nosilec.vat)) / 100
          nosilec.amount = ((nosilec.amount * this.davek) / 100).toFixed(4).replace('.', ',') + ' €'
        }
        let tmpArray = []
        this.dolzinaSeznamaStroskovniPregled = this.tempSeznamNosilci.length
        const chunk = 4
        for (let i = 0; i < this.dolzinaSeznamaStroskovniPregled; i += chunk) {
          tmpArray.push(this.tempSeznamNosilci.slice(i, i + chunk))
        }
        this.tempSeznamNosilci = tmpArray
        this.PrikaziStran(1)
      }
    },
    PrikaziStran (stran) {
      this.trenutnoIzbranaStran = stran
      if (typeof this.tempSeznamNosilci[this.trenutnoIzbranaStran - 1] !== 'undefined') {
        this.seznamNosilci = this.tempSeznamNosilci[this.trenutnoIzbranaStran - 1]
      } else {
        this.seznamNosilci = []
      }
      this.nalaganjePorabaStroskovniNosilci = false
    },
    ErrPregledNosilce (podatki, prenosniParametri) {
      prenosniParametri.call_duration = 0
      prenosniParametri.message_count = 0
      prenosniParametri.amount = '0.00' + ' €'
      prenosniParametri.data_quantity_kb = 0
      this.tempSeznamNosilci.push(prenosniParametri)
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjePorabaStroskovniNosilci = false
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Poraba/PorabaTelefonija/StroskovniPregled.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaTelefonija/StroskovniPregled.vue